<div class="modal-body">
  <i
    class="cds-icon-close v-hover p-absolute close-button"
    (click)="closeModal()"
  ></i>

  <i class="cds-icon-edit text-center icon-edit"></i>

  <h2 class="text-bold text-center title">
    Editar apelido do produto
  </h2>

  <hr />

  <p class="text-center">
    Dê um nome personalizado a este cartão para facilitar sua identificação.
    O apelido ajuda sua empresa a encontrar rapidamente o produto certo entre os demais.
  </p>

  <h2 class="text-bold text-center product-name">
    {{ modalRef.data?.name?.trim().length ? modalRef.data?.name : '-' }}
  </h2>

  <div class="input-container">
    <input
      class="cds-form-field"
      type="text"
      placeholder="Digite o apelido aqui"
      [formControl]="contractedProductName"
      [maxlength]="maxLength"
    />
  </div>

  <button
    type="button"
    class="cds-button s-solid c-primary"
    [loading]="loading()"
    [disabled]="!contractedProductName.value?.length || loading()"
    (click)="onSubmit()"
    cdsButtonLoading
  >
    Confirmar
  </button>
</div>
